<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f5f7fa;
  padding: 20px;
  min-height: calc(100vh - 60px);

  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 4px solid #409eff;
    font-size: 18px;
    font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
    color: #303133;
    font-weight: 600;
    padding-left: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .content_box {
    background: #fff;
    box-sizing: border-box;
    width: 100%;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  }
}

.query_item {
  padding: 10px 0 20px 0;
  text-align: right;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 20px;

  ::v-deep .el-form-item {
    margin-bottom: 0;
    margin-right: 15px;
  }

  ::v-deep .el-button {
    margin-left: 10px;
  }
}

.table_item {
  margin-top: 10px;
}

.event_bar_box {
  width: 100%;
  height: 400px;
  margin-top: 30px;
  padding: 20px 0;
}
</style>
<template>
  <div
      class="box"
      v-loading="loading"
      element-loading-text="正在查询,请稍候..."
  >
    <p class="page_title">人员出入统计</p>
    <div class="content_box">
      <el-row>
        <el-col>
          <div class="query_item">
            <el-form :inline="true" :model="form" class="demo-form-inline" ref="form">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.userName" placeholder="姓名" clearable></el-input>
              </el-form-item>
              <el-form-item label="角色类型：" prop="userType">
                <el-select
                    v-model="form.userType"
                    placeholder="请选择"
                    size="medium"
                    clearable
                >
                  <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="时间范围：" prop="userTime">
                <el-date-picker
                    v-model="form.userTime"
                    type="daterange"
                    unlink-panels
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="状态" prop="state">
                <el-select v-model="form.state" placeholder="请选择" clearable>
                  <el-option label="告警中" value="0"></el-option>
                  <el-option label="告警解除" value="1"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="queryAlarm">查询</el-button>
                <el-button @click="queryAlarm('clean')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="table_item">
            <data-table
                height="350"
                :columns="tableColumns"
                :data="tableData1"
                @selects="selects"
                :borderable="true"
                :selectable="false"
            >
            </data-table>
            <Pagination :page.sync="page" @pageChange="queryAlarm"/>
          </div>
        </el-col>
        <!--        <el-col :span="8">-->
        <!--          <div class="event_pie_box" id="event_pie"></div>-->
        <!--        </el-col>-->
      </el-row>
      <div class="event_bar_box" id="event_bar"></div>
    </div>
  </div>
</template>
<script>
import index from "@/components/mixins/index";
import optionVal from "@/components/mixins/optionVal";
import {getHistogramData, getMothPassData, getPeopleFlow} from "./api";
import {findPeoplePassRecord, getUserType} from "../trafficMange/api";

export default {
  mixins: [index, optionVal],
  data() {
    return {
      form: {
        areaId: "",
        userName: "",
        userType: "",
        userTime: [],
        state: "",
        time: "",
      },
      loading: false,
      info: {
        today_alarm_num: 6,
        today_alarm_rate: "15.9%",
        month_alarm_num: 156,
        month_alarm_rate: "12.8%",
        today_patrol_num: 12,
        month_patrol_num: 89,
        event_report_num: 25,
      },
      options: [
      ],
      tableColumns: [
        {label: "姓名", prop: "userName", minWidth: "60", sort: true},
        { label: "角色类型", prop: "userTypeText", minWidth: "60" },
        { label: "身份证号", prop: "idCard", minWidth: "60" },
        { label: "出入时间", prop: "passTime", minWidth: "60" },
        { label: "出入口门禁名称", prop: "passRoomName", minWidth: "60" },
        { label: "学号", prop: "snumber", minWidth: "60" },
        { label: "学院", prop: "college", minWidth: "60" },
        { label: "专业", prop: "major", minWidth: "60" },
        { label: "班级", prop: "clazz", minWidth: "60" },
      ],
      tableData1: [],
      defaultProps: {
        children: "children",
        label: "areaName",
        value: "id",
      },
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 选择第一个日期时，禁用7天前的日期
          if (minDate && !maxDate) {
            const minTime = minDate.getTime();
            this.pickerOptions.disabledDate = (time) => {
              const diff = Math.abs(time.getTime() - minTime);
              return diff > 7 * 24 * 3600 * 1000;
            };
          } else {
            this.pickerOptions.disabledDate = null;
          }
        },
        disabledDate: (time) => {
          // 如果已经选择了两个日期，不做限制
          return false;
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      treeData: [],
    };
  },
  methods: {
    // 获取今天的日期范围
    getTodayRange() {
      const today = new Date();
      const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
      return [this.formatDate(start), this.formatDate(end)];
    },
    // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getUserType(){
      getUserType('1002')
          .then((res) =>{
            this.options = res.data.data.filter((item) => {
              if(item.value != "100203") return item;
            });
          })
    },
    initEventBar() {
      let data = Object.assign({},this.form);
      if(this.form.userTime==''){
        data.userTime = null;
      }else {
        data.userTime = null;
        data.startDate = this.form.userTime[0]
        data.endDate =this.form.userTime[1]
      }
      getMothPassData(data).then(res => {
        let histogramXAxis = [];
        let histogramYData1 = [];
        let histogramYData2 = [];
        res.data.data.forEach(obj => {
          histogramXAxis.push(obj["month"]);
          histogramYData1.push(obj["inNum"]);
          histogramYData2.push(obj["outNum"]);
        });
        let option = {
          xAxis: {
            type: "category",
            data: histogramXAxis,
          },
          yAxis: {
            type: "value",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          grid: {
            top: "13%",
            left: "1%",
            right: "4%",
            bottom: "13%",
            containLabel: true,
          },
          legend: {
            data: ["进校人数", "出校人数"],
            x: "center", //可设定图例在左、右、居中
            y: "bottom",
          },
          series: [
            {
              name: "进校人数",
              data: histogramYData1,
              type: "bar",
              itemStyle: {
                color: "#6395fa",
              },
            },
            {
              name: "出校人数",
              data: histogramYData2,
              type: "bar",
              itemStyle: {
                color: "#fa7a63",
              },
            },
          ],
        };
        let myChart = this.$echarts.init(document.getElementById("event_bar"));
        myChart.clear();
        myChart.setOption(option, true);
      }).catch(() => {
        this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
          type: "error",
        });
      });
    },
    queryAlarm(form) {
      if(form==='clean') {
        this.form={
          userName: "",
          userType: "",
          userTime: this.getTodayRange()
        }
      }
      // 验证时间范围不超过7天
      if (this.form.userTime && this.form.userTime.length === 2) {
        const startDate = new Date(this.form.userTime[0]);
        const endDate = new Date(this.form.userTime[1]);
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 7) {
          this.$message.warning('查询时间范围不能超过7天');
          return;
        }
      }
      let data = Object.assign({},this.form);
      if(!this.form.userTime || this.form.userTime.length === 0){
        data.startDate = null;
        data.endDate = null;
      }else {
        data.startDate = this.form.userTime[0];
        data.endDate = this.form.userTime[1];
      }
      delete data.userTime;
      data.current = this.page.pageNum;
      data.size = this.page.pageSize;
      findPeoplePassRecord(data)
          .then((res) => {
            this.tableData1 = res.data.data.records;
            this.page.total = res.data.data.total;
            this.initEventBar()
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "查询失败", {
              type: "error",
            })
          });
    },
      // let data = new FormData();
      // data.current = this.page.pageNum;
      // data.size = this.page.pageSize;
      // data.name = this.form.name;
      // getPeopleFlow(data).then(res => {
      //   this.tableData1 = res.data.data.records;
      //   this.page.total = res.data.data.total;
      //   this.tableData1.forEach(item => {
      //     item.userPosition = item.userPosition == "0" ? "入校" : "出校";
      //     // item.triggerType = this.triggerTypeOptions.get(item.triggerType);
      //   });
      // });
    },
  mounted() {
    // 设置默认时间为今天
    this.form.userTime = this.getTodayRange();
    //初始化列表
    this.queryAlarm();
    //获取人员类型
    this.getUserType();
  }
}
</script>

